var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewcataloggridicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 1.7C0.5 1.03726 1.03726 0.5 1.7 0.5H4.1C4.76274 0.5 5.3 1.03726 5.3 1.7V4.1C5.3 4.76274 4.76274 5.3 4.1 5.3H1.7C1.03726 5.3 0.5 4.76274 0.5 4.1V1.7Z",
    stroke: "#A4A4A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7 1.7C7.7 1.03726 8.23726 0.5 8.9 0.5H11.3C11.9627 0.5 12.5 1.03726 12.5 1.7V4.1C12.5 4.76274 11.9627 5.3 11.3 5.3H8.9C8.23726 5.3 7.7 4.76274 7.7 4.1V1.7Z",
    stroke: "#A4A4A4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9 1.7C14.9 1.03726 15.4373 0.5 16.1 0.5H18.5C19.1627 0.5 19.7 1.03726 19.7 1.7V4.1C19.7 4.76274 19.1627 5.3 18.5 5.3H16.1C15.4373 5.3 14.9 4.76274 14.9 4.1V1.7Z",
    stroke: "#A4A4A4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 8.9C0.5 8.23726 1.03726 7.7 1.7 7.7H4.1C4.76274 7.7 5.3 8.23726 5.3 8.9V11.3C5.3 11.9627 4.76274 12.5 4.1 12.5H1.7C1.03726 12.5 0.5 11.9627 0.5 11.3V8.9Z",
    stroke: "#A4A4A4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7 8.9C7.7 8.23726 8.23726 7.7 8.9 7.7H11.3C11.9627 7.7 12.5 8.23726 12.5 8.9V11.3C12.5 11.9627 11.9627 12.5 11.3 12.5H8.9C8.23726 12.5 7.7 11.9627 7.7 11.3V8.9Z",
    stroke: "#A4A4A4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9 8.9C14.9 8.23726 15.4373 7.7 16.1 7.7H18.5C19.1627 7.7 19.7 8.23726 19.7 8.9V11.3C19.7 11.9627 19.1627 12.5 18.5 12.5H16.1C15.4373 12.5 14.9 11.9627 14.9 11.3V8.9Z",
    stroke: "#A4A4A4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 16.1C0.5 15.4373 1.03726 14.9 1.7 14.9H4.1C4.76274 14.9 5.3 15.4373 5.3 16.1V18.5C5.3 19.1627 4.76274 19.7 4.1 19.7H1.7C1.03726 19.7 0.5 19.1627 0.5 18.5V16.1Z",
    stroke: "#A4A4A4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7 16.1C7.7 15.4373 8.23726 14.9 8.9 14.9H11.3C11.9627 14.9 12.5 15.4373 12.5 16.1V18.5C12.5 19.1627 11.9627 19.7 11.3 19.7H8.9C8.23726 19.7 7.7 19.1627 7.7 18.5V16.1Z",
    stroke: "#A4A4A4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9 16.1C14.9 15.4373 15.4373 14.9 16.1 14.9H18.5C19.1627 14.9 19.7 15.4373 19.7 16.1V18.5C19.7 19.1627 19.1627 19.7 18.5 19.7H16.1C15.4373 19.7 14.9 19.1627 14.9 18.5V16.1Z",
    stroke: "#A4A4A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewcataloggridicon);
export default __webpack_public_path__ + "static/media/newcataloggridicon.4248bc02a48bc1d60615773265c2d1ae.svg";
export { ForwardRef as ReactComponent };